import {watch} from 'vue';
import {useCookie, useState} from 'nuxt/app';

export function useMaltVisitorId() {
    const maltVisitorIdCookie = useCookie('malt-visitorId');
    // Default state comes from cookie
    const maltVisitorId = useState('malt-visitorId', () => maltVisitorIdCookie.value);

    // Only sync state to cookie on client-side
    // Server-side watchers can cause memory leaks in SSR as they may not be properly disposed
    if (import.meta.client) {
        watch(maltVisitorId, (value) => {
            // Update cookie when state changes
            maltVisitorIdCookie.value = value;
        });
    }

    return maltVisitorId;
}
